.paper {
  display: flex;
  color: inherit;
}

.content {
  font-size: 12px;
  display: flex;
  align-items: center;
  padding-left: 8px;
  padding-right: 8px;
}
